export enum ManifestSearchFilter {
  MANIFEST_NUMBER = 'MANIFEST_NUMBER',
  CLIENT = 'CLIENT',
  SCAC = 'SCAC',
  LOCATION = 'LOCATION',
  STATUS = 'STATUS',
  SOURCE = 'SOURCE',
  MANIFEST_DATE = 'MANIFEST_DATE',
}
